import React, { useEffect, useState } from "react";
import SM from "../../DIsplay/Screen/SM";
import { SwipeableDrawer } from "@mui/material";
import Icon from "../../HOC/Icon";
import InvoiceMenuBoard from "./InvoiceMenuBoard";
import InvoiceCustomerMenuBoard from "./InvoiceCustomerMenuBoard";
import { CreateCustomerModal } from "../../modal/createInvoice/CreateCustomerModal";
import { DeleteServiceModal } from "../../modal/createInvoice/DeleteServiceModal";

const InvoiceCustomerMenu = ({ order, og }) => {
  const [open, setOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <>
      <div
        className="cursor-pointer p-2 relative "
        onClick={() => setOpen(true)}
      >
        <img
          src="/IconMore.svg"
          alt=""
          className="h-5 object-contain relative"
        />
        <SM className="">
          {open && (
            <InvoiceCustomerMenuBoard
              setEditModal={setEditModal}
              setDeleteModal={setDeleteModal}
              order={order}
            />
          )}
        </SM>
        <SM lt>
          <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            SlideProps={{ className: "max-h-[50vh]" }}
          >
            <div className="flex flex-col h-full flex-1 gap-2 relative">
              <div
                className="flex gap-4 justify-between items-center shadow p-4"
                onClick={() => setOpen(false)}
              >
                <div className="flex items-center gap-2">
                  <Icon icon="mingcute:left-line" /> Order Menus
                </div>
                <button>
                  <Icon icon="mdi:close" />
                </button>
              </div>
              <div className="overflow-y-auto">
                <InvoiceMenuBoard order={order} mobile={true} />
              </div>
            </div>
          </SwipeableDrawer>
        </SM>
      </div>
      <CreateCustomerModal
        open={editModal}
        setOpen={setEditModal}
        order
        edit
        customer={og}
      />
      <DeleteServiceModal
        open={deleteModal}
        setOpen={setDeleteModal}
        customer={og}
      />
    </>
  );
};

export default InvoiceCustomerMenu;
